import {useQuery} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {getTransactionLoadingSponsorDataParams} from './type';
import {getTransactionLoadingSponsor} from '.';

const useGetLoadingTransactionSponsor = (
  params: getTransactionLoadingSponsorDataParams,
) => {
  const navigate = useNavigate();
  const {isLoading, data} = useQuery({
    queryKey: ['sponsor-payment-loading-', params],
    queryFn: () => getTransactionLoadingSponsor(params),
    onSuccess(data) {
      data &&
        data.status &&
        navigate(
          data.status === 'check'
            ? '/sponsor/payment/success'
            : `/sponsor/payment/failure`,
          {
            replace: true,
            state: {
              data,
              retryNavigate: {
                route: '/sponsor/new-plan',
                stae: {},
              },
            },
          },
        );
    },
  });
  return {isLoading, data};
};

export default useGetLoadingTransactionSponsor;
